import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReportAndAnalyticsAPI from "../../services/reportAndAnalyticsService";

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      const data = await ReportAndAnalyticsAPI.fetchDashboardReportsAndAnalytics();
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to load dashboard data');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    loading: false,
    error: null,
    stats: {
      totalOrders: 0,
      revenue: 0,
      pending: 0,
      customers: 0,
      lowStock: 0,
      totalOrdersChange: 0,
      revenueChange: 0,
      pendingChange: 0
    },
    salesTrends: [],
    bestSellers: [],
    customerGrowth: {
      newPercent: 0,
      returningPercent: 0
    }
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = {
          totalOrders: action.payload.stats.total_orders,
          revenue: action.payload.stats.revenue,
          pending: action.payload.stats.pending,
          customers: action.payload.stats.customers,
          lowStock: action.payload.stats.low_stock,
          totalOrdersChange: action.payload.stats.total_orders_change,
          revenueChange: action.payload.stats.revenue_change,
          pendingChange: action.payload.stats.pending_change
        };
        state.salesTrends = action.payload.sales_trends;
        state.bestSellers = action.payload.best_sellers;
        state.customerGrowth = {
          newPercent: action.payload.customer_growth.new_percent,
          returningPercent: action.payload.customer_growth.returning_percent
        };
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default dashboardSlice.reducer;